module.exports = __webpack_public_path__ + "img/smartDoorMagnet.ba018c3a.png";